import { CustomTheme, DeleteOutlineIcon } from '@orijinworks/frontend-commons';
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Pagination as PaginationComponent,
  Stack,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { keyframes } from '@emotion/react';
import { Typography as MUITypography } from '@orijinworks/frontend-commons';

export const AuditUpdatedByTypographySX = {
  width: 157,
  '& .MuiAvatar-root': {
    fontWeight: 'bold',
    width: 52,
    height: 52
  }
};

const msgBubble = keyframes`
   0% {
        transform: translateY(100%);
        visibility: hidden;
      }
      100% {
        visibility: visible;
        transform: translateY(0);
      }
`;

export const FeedsWrapper = styled(Box)(({ theme }) => ({
  padding: '40px 30px 0',
  [theme.breakpoints.between('xs', 'sm')]: {
    '&.announcements, &.all': {
      '& .flat-on-mobile': {
        gap: 10,
      },
    },
  },
}));

export const InLineBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  [theme.breakpoints.between('xs', 'sm')]: {
    '&.flat-on-mobile': {
      flexDirection: 'column',
    },
  },
}));
export const ChannelViewStyle = (theme) => ({
  [theme.breakpoints.between('xs', 'sm')]: {
    flexDirection: 'column',
    gap: 10,
    marginTop: 10,
  },
});
export const AnnouncementChipStyle = (theme) => ({
  [theme.breakpoints.between('xs', 'sm')]: {
    flexDirection: 'column',
    gap: 10,
    alignItems: 'flex-start',
    marginTop: 10,
  },
});

const TOGGLE_BUTTON_STYLES = (theme) => {
  return {
    minWidth: 184,
    height: 40,
    fontSize: 16,
    fontFamily: 'Inter',
    fontWeight: 700,
    textTransform: 'capitalize',
    '&.Mui-selected': {
      backgroundColor: CustomTheme.palette.navy.main + ' !important',
      color: '#ffffff',
    },
  }
};


export const AuditToggleButtonContainer = styled(Box)(({ theme }) => ({
  '& .toggle-button-left': {
    ...TOGGLE_BUTTON_LEFT(theme),
  },
  '& .toggle-button-middle': {
    ...TOGGLE_BUTTON_STYLES(theme),
  },
  '& .toggle-button-right': {
    ...TOGGLE_BUTTON_RIGHT(theme),
  },
}));


export const TOGGLE_BUTTON_LEFT = (theme) => ({
  ...TOGGLE_BUTTON_STYLES(theme),
  borderTopLeftRadius: 100,
  borderBottomLeftRadius: 100,
  minWidth: 130,
});

export const TOGGLE_BUTTON_RIGHT = (theme) => ({
  ...TOGGLE_BUTTON_STYLES(theme),
  borderTopRightRadius: 100,
  borderBottomRightRadius: 100,
  minWidth: 130,
});

export const TOGGLE_BUTTON_MIDDLE = (theme) => ({
  ...TOGGLE_BUTTON_STYLES(theme),
});

export const SearchInput = (theme) => ({
  minWidth: 420,
  width: 420,
  maxWidth: '100%',
  fontSize: 16,
  '& svg': {
    color: CustomTheme.palette?.grey110.main,
  },
  '& input': {
    height: 79,
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
    '.hide-mobile': {
      display: 'none',
    },
    '.show-mobile': {
      display: 'initial',
    },
  },
});

export const NewButton = {
  minWidth: 220,
  marginLeft: '15px',
  maxWidth: '100%',
  whiteSpace: 'nowrap',
};

export const GreyTypography = styled(MUITypography)(({ theme }) => ({
  color: CustomTheme.palette.grey110.main,
  '&.trim-text': {
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  '&.trim-text-1': {
    '-webkit-line-clamp': '1',
  },
}));

export const TrimTextTypo = styled(MUITypography)(() => ({
  display: '-webkit-box',
  '-webkit-line-clamp': '2',
  '-webkit-box-orient': 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

export const Grey90Typography = styled(MUITypography)(
  ({ theme }) => ({
    color: CustomTheme.palette.grey90.main,
  }),
);

export const Grey100Typography = styled(MUITypography)(
  ({ theme }) => ({
    color: CustomTheme.palette.grey100.main,
  }),
);

export const NavyMainTypography = styled(MUITypography)(
  ({ theme }) => ({
    color: CustomTheme.palette.navy.main,
  }),
);

export const Tag = styled(Box)(({ theme }) => ({
  color: 'white',
  padding: '3px 8px',
  borderRadius: 4,
  '&.New': {
    background: `linear-gradient(101deg, ${CustomTheme.palette.purple.light} -2.99%, ${CustomTheme.palette.red.main} 48.85%, ${CustomTheme.palette.orange.main} 100.68%)`,
  },
  '&.Private': {
    background: `linear-gradient(105deg, ${CustomTheme.palette.purple.main} 0%, ${CustomTheme.palette.blue.main} 100%)`,
  },
  '&.LimitedReplies': {
    backgroundColor: CustomTheme.palette.cerulean.main,
  },
  '&.MonitoredByAdmin': {
    backgroundColor: CustomTheme.palette.orange.dark,
  },
  '& *': {
    fontSize: 18,
  },
}));

export const IndividualFeedBox = styled(Box)(({ theme }) => ({
  border: `1px solid ${CustomTheme.palette.grey70.main}`,
  borderRadius: 24,
  padding: 24,
  marginTop: 15,
  '&.new': {
    boxShadow: `-8px 0 0 0 ${CustomTheme.palette.blue.main}`,
  },
}));

export const Chip = styled(Box)(({ theme }) => ({
  minHeight: 28,
  padding: '0px 10px',
  display: 'flex',
  alignItems: 'center',
  borderRadius: 4,
  color: 'white',
  '&.aqua': {
    backgroundColor: CustomTheme.palette.aqua.light,
    color: CustomTheme.palette.primary.dark,
  },
  '& *': {
    fontWeight: 700 + ' !important',
  },
  '&.green': {
    background: 'rgba(140, 217, 180, 0.20)',
    color: CustomTheme.palette.green.deep,
  },
  '&.purple': {
    backgroundColor: 'rgba(173, 156, 226, 0.20)',
    color: CustomTheme.palette.purple.deep,
  },
  '&.blue': {
    backgroundColor: CustomTheme.palette.cerulean.main,
  },
  '&.orange': {
    backgroundColor: CustomTheme.palette.orange.dark,
  },
  '&.secondary': {
    backgroundColor: CustomTheme.palette.secondary.deep,
  },
  '&.private': {
    background: `linear-gradient(105deg, ${CustomTheme.palette.purple.main} 0%, ${CustomTheme.palette.blue.main} 100%)`,
  },
  '&.new': {
    background: `linear-gradient(101deg, ${CustomTheme.palette.purple.light} -2.99%, ${CustomTheme.palette.red.main} 48.85%, ${CustomTheme.palette.orange.main} 100.68%)`,
  },
}));

export const DeleteIcon = styled(DeleteOutlineIcon)(
  ({ theme }) => ({
    color: CustomTheme.palette.grey100.main,
  }),
);
export const AddIconButton = styled(IconButton)(
  ({ theme }) => ({
    border: `1px solid ${CustomTheme.palette.grey100.main}`,
    width: 40,
    height: 40,
    fontSize: 24,
    margin: '5px 0px',
  }),
);

export const ContentBody = styled(Box)(({ theme }) => ({
  borderBottom: `1px solid ${CustomTheme.palette.grey60.main}`,
  paddingBottom: 10,
}));

export const HideButton = styled(Button)(({ theme }) => ({
  borderColor: `${CustomTheme.palette.purple.main} !important`,
  color: CustomTheme.palette.purple.main,
  width: 111,
  height: 45,
  '& svg': {
    fontSize: 16,
    marginRight: 5,
  },
}));

export const AttachmentBox = styled(Box)(({ theme }) => ({
  borderRadius: 16,
  border: `1px solid ${CustomTheme.palette.grey60.main}`,
  backgroundColor: 'white',
  margin: '20px 0px',
  '& .file-icon-container': {
    marginTop: 5,
    marginRight: 10,
  },
  '& .file-size': {
    borderRadius: 4,
    border: `1px solid ${CustomTheme.palette.grey100.main}`,
    padding: '0px 5px',
  },
}));

export const StandardButtonSize = {
  minWidth: 134,
  minHeight: 48,
};
export const NavyMainButton = styled(Button)(({ theme }) => {
  return {
    fontSize: 16,
    textTransform: 'capitalize',
    fontWeight: 'bold',
    borderColor: CustomTheme.palette.navy.main + ' !important',
    color: CustomTheme.palette.navy.main + ' !important',
    ...StandardButtonSize,
  };
});

export const PrimaryButtonStyles = {
  backgroundColor: 'var(--blue-main)',
  fontSize: 16,
  fontWeight: 700,
  textTransform: 'capitalize'
}

export const MenuStyled = styled(Menu)(() => ({
  '& .MuiPaper-root': {
    minWidth: 250,
    borderRadius: 24,
    boxShadow:
      '0 1px 2px 0 rgba(0, 0, 0, 0.30), 0 2px 6px 2px rgba(0, 0, 0, 0.15)',
  },
}));

export const MenuItemStyled = styled(MenuItem)(() => ({
  height: 56,
}));

export const MessageViewWrapper = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'hidden',
  boxSizing: 'border-box',
};

export const FeedsApplicationStyles = {
  '& > div:nth-child(3)': {
    height: 'calc(100vh - 235px)',
  },
}


export const Pagination = styled(PaginationComponent)(
  ({ theme }) => ({
    '& .MuiButtonBase-root': {
      minWidth: 24,
      height: 20,
      fontSize: 12,
      borderRadius: 4,
      color: CustomTheme.palette.navy.main,
      letterSpacing: '0.24px',
      lineHeight: '22px',
    },
    '& .Mui-selected': {
      fontWeight: 'bold',
      color: 'white',
      backgroundColor: CustomTheme.palette.navy.main + ' !important',
    },
  }),
);

export const MessageBubbleStyled = styled(Box)(
  ({ theme }) => ({
    color: 'white',
    padding: 24,
    borderRadius: 10,
    maxWidth: '80%',
    marginTop: 10,
    position: 'relative',
    visibility: 'hidden',
    animation: `${msgBubble} 0.5s ease-out 1s forwards`,
    '& .message-bubble-text': {
      hyphens: 'auto',
      overflowWrap: 'break-word',
      wordBreak: 'break-word',
    },
    '&.not-sent': {
      opacity: 0.7,
    },
    '&.sender': {
      marginLeft: 'auto',
      background: `linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), ${CustomTheme.palette.aqua.deep}`,
      '& svg': {
        position: 'absolute',
        bottom: 0,
        right: -10,
      },
    },
    '&.receiver': {
      background: CustomTheme.palette.grey30.main,
      color: '#2E3032',
      '& svg': {
        position: 'absolute',
        bottom: 0,
        left: -10,
      },
    },
    '& p': {
      margin: '0px !important',
    },
  }),
);

export const FeedDivider = styled(Box)(({ theme }) => ({
  color: CustomTheme.palette.grey80.main,
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  margin: '10px 0px',
  '& p': {
    zIndex: 99,
    backgroundColor: 'white',
    padding: '5px 10px',
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: 16,
    zIndex: 98,
    width: '100%',
    height: 1,
    backgroundColor: CustomTheme.palette.grey60.main,
  },
}));

export const MessageBubbleCitation = styled(Stack)(() => ({
  marginTop: 20,
  '& h3': {
    fontSize: 16,
  },
}));

export const DirectMessageFromTo = (theme) => ({
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& h6': {
      marginLeft: '0px !important',
    },
  },
});

export const ConversationMembersModalStyles = (theme) => ({
  maxWidth: '420px',
  margin: '0px auto',
  borderRadius: '24px',
  '& .modal-body': {
    paddingTop: '10px',
  },
  '& .modal-footer': {
    flexFlow: 'row-reverse',
    '& div': {
      flexFlow: 'row-reverse',
      '& button:nth-child(1)': {
        marginLeft: '10px',
      },
    },
  },
  '& h5': {
    color: CustomTheme.palette.navy.main,
    marginBottom: '5px',
  },
  '& p': {
    color: CustomTheme.palette.grey110.main,
  },
});

export const GroupsIconContainer = styled(Box)(
  ({ theme }) => ({
    display: 'flex',
    width: '52px',
    height: '52px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50px',
    background: `linear-gradient(96deg, ${CustomTheme.palette.aqua.extraDeep} 29.83%, ${CustomTheme.palette.green.dark} 114.37%)`,
  }),
);

export const AndOthersLink = styled(MUITypography)(
  ({ theme }) => ({
    color: CustomTheme.palette.cerulean.main,
    whiteSpace: 'nowrap',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '24px',
    letterSpacing: '0.32px',
    leadingTrim: 'both',
    textEdge: 'cap',
    cursor: 'pointer',
    display: 'inline',
  }),
);

export const ConversationMembersContent = styled(Box)({ padding: '20px 0' });

export const ConversationMembersTitle = styled(MUITypography)(
  ({ theme }) => ({
    marginBottom: '16px',
    fontWeight: 'bold',
    color: CustomTheme.palette.navy.main,
  }),
);

export const ConversationMembersText = styled(MUITypography)(
  ({ theme }) => ({
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    lineHeight: 1.6,
    color: CustomTheme.palette.grey110.main,
  }),
);

export const DeleteModalStyles = (theme) => ({
  maxWidth: '420px',
  margin: '0px auto',
  '& .modal-body': {
    paddingTop: '10px',
  },
  '& .modal-footer': {
    flexFlow: 'row-reverse',
    '& div': {
      flexFlow: 'row-reverse',
      '& button:nth-child(1)': {
        marginLeft: '10px',
      },
    },
  },
  '& h5': {
    color: CustomTheme.palette.navy.main,
    marginBottom: '5px',
  },
  '& p': {
    color: CustomTheme.palette.grey110.main,
  },
});

export const AlertStyle = (theme) => ({
  alignItems: 'center',
  borderRadius: '12px 12px 0 0',
  '& svg': {
    fontSize: 32,
    color: CustomTheme.palette.orange.dark,
  },
  '&.editor-hidden': {
    borderRadius: '0px',
  },
});
export const VerticalDivider = styled(Box)(({ theme }) => ({
  position: 'absolute',
  width: 1,
  height: 150,
  top: 25,
  bottom: 0,
  backgroundColor: CustomTheme.palette.grey60.main,
}));

export const AuditLogButton = styled(Button)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  right: 40,
  zIndex: 99,
  width: 140,
  height: 40,
  backgroundColor: 'white',
  borderColor: CustomTheme.palette.aqua.deep,
  color: CustomTheme.palette.aqua.deep,
  fontWeight: 700,
  fontSize: 16,
  textTransform: 'capitalize',
  '&:hover': {
    borderColor: CustomTheme.palette.aqua.deep,
  },
  '& svg': {
    fontSize: 16,
    marginRight: 5,
  },
}));